import { render, staticRenderFns } from "./yingshou.vue?vue&type=template&id=c0bd2632&scoped=true&"
import script from "./yingshou.vue?vue&type=script&lang=js&"
export * from "./yingshou.vue?vue&type=script&lang=js&"
import style0 from "./yingshou.vue?vue&type=style&index=0&id=c0bd2632&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bd2632",
  null
  
)

export default component.exports